import React from "react"
import { UserDto } from "../../generated";
import { GetTable } from "../../common/components/DataTable"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
const Table = GetTable<UserDto>();

export const OperatorsTable = (props: { data: UserDto[], }) => {

    return <Table
        data={props.data}
        keySelector={x => x.codOperatore.toString()}
        filterables={[x => x.nomeOperatore, x => x.username, x => x.codOperatore]}
        classNameSelector={x => x.disabilitato ? "text-danger" : ""}
    >
        <Table.Column template={x => <Link to={links.operatorEdit(x.codOperatore)}>{x.username}</Link>} header="Username" />
        <Table.Column template={x => x.nomeOperatore} header="Nome Operatore" />
        <Table.Column
            headerClassName="text-center"
            className="text-center"
            template={x => x.amministratore ? <i className="text-success fas fa-check" /> : null}
            header="Amministratore"
        />
        <Table.Column
            headerClassName="text-center"
            className="text-center"
            header="Disabilitato"
            template={x => x.disabilitato ? <i className="fas fa-check" /> : null}
        />
        {/* <Table.Column template={x => <Link to={links.impiantoEdit(props.idCliente, x.idImpianto)}>{x.idImpianto}</Link>} header="Id Impianto" /> */}
    </Table>

}